<template>
    <div class="my-set-sub-page layout-sub-page">
        <!-- 1. 顶部标题栏 -->
        <title-bar v-bind:titleData="titleData" v-bind:backFunc="clickBack"></title-bar>
        <!-- 2. 提示内容 -->
        <div class="my-set-telephone-content">
            <h3>绑定新手机</h3>
            <div class="my-set-telc-p">
                <p>当前登录手机号：{{userData.mobile}}</p>
                <p>更换手机号后，下次登录可使用新手机号登录。</p>
            </div>
        </div>
        <!-- 3. 表单 -->
        <div class="my-set-telephone-form">
            <div class="my-set-line">
                <input class="my-set-input" placeholder="请输入手机号码" @input="checkVerifyLocked" v-model="telNumValue" maxlength="11" type="text">
            </div>
            <div class="my-set-line dsp-flex">
                <input class="my-set-input" placeholder="请输入验证码" @input="checkCode" v-model="codeValue" maxlength="4" type="text">
                <div class="my-set-line-right">
                    <span class="my-set-lrb"></span>
                    <button class="my-set-verify" @click="clickGetCode">
                        <span v-bind:class="{'gray': verifyLocked || loginData.lockCode}">{{loginData.lockCode ? loginData.lockTime : '立即获取'}}</span>
                    </button>
                </div>
            </div>
            <!-- <div class="my-set-sub-note">该手机号已绑定其它登录账号，请先解绑</div> -->
        </div>
        <!-- 4. 按钮 -->
        <div class="my-set-button">
            <button class="button-green" v-bind:class="{'button-gray': !canClick}" v-bind:disabled="!canClick" @click="clickBind">完成绑定</button>
        </div>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import { MIX, UTILS } from '../../modules/utils';
export default {
    name: 'MySetTelephone',
    components: { TitleBar },
    computed: {
        userData() {
            return this.$store.state.userData;
        },
        loginData() {
            return this.$store.state.loginData;
        }
    },
    data() {
        return {
            titleData: {'titleText': '', 'showCancel': false},
            telNumValue: '',
            codeValue: '',
            verifyLocked: true,
            canClick: false
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initData();
            MIX.trackPageViewed('BindPhone');
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.minHeight = innerHeight + 'px';
            this.$store.dispatch('resetLoginCode');
        },
        initData() {
            this.telNumValue = this.loginData.newMobile ? this.loginData.newMobile : this.telNumValue;
        },
        clickBack() {
            this.$router.replace('/my');
        },
        checkVerifyLocked() {
            if(this.telNumValue != '') {
                this.verifyLocked = !UTILS.isPoneAvailable(parseInt(this.telNumValue));
            }
        },
        clickGetCode() {
            // 获取二维码按钮被锁定
            if(this.verifyLocked) {
                return;
            }

            var me = this;
            this.$store.dispatch('getLoginCode', {
                tel: this.telNumValue,
                type: '2',
                sucCb: function() {
                    me.verifyLocked = false;
                    me.$toast('发送验证码成功，请注意查收');
                }
            })
        },
        checkCode() {
            this.canClick = this.codeValue.length == 4 ? true : false;
        },
        clickBind() {
            var me = this;
            this.$store.dispatch('getUserBind', {
                tel: this.telNumValue,
                code: this.codeValue,
                sucCb: function() {
                    me.$toast('绑定成功！');
                    me.telNumValue = "";
                    setTimeout(() => {
                        me.$router.replace('/my');
                    }, 100);
                }
            })
        }
    }
}
</script>